export const MAP_PERFIL = [
  {
    id: 1,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Livro de Registro',
    prefixoNomeArq: 'Livro_de_Registro'
  },
  {
    id: 2,
    livro: ['N'],
    desc: 'Declaração de Nascido Vivo',
    prefixoNomeArq: 'Declaracao_de_Nascido_Vivo'
  },
  {
    id: 3,
    livro: ['O', 'NT'],
    desc: 'Declaração de Óbito',
    prefixoNomeArq: 'Declaracao_de_Obito'
  },
  {
    id: 4,
    livro: ['C', 'CR'],
    desc: 'Habilitação de Casamento',
    prefixoNomeArq: 'Habilitacao_de_Casamento'
  },
  {
    id: 5,
    livro: ['N'],
    desc: 'Declaração de Maternidade',
    prefixoNomeArq: 'Declaracao_de_Maternidade'
  },
  {
    id: 6,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Outros Documentos',
    prefixoNomeArq: 'Outros_Documentos'
  },
  {
    id: 7,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Mandado',
    prefixoNomeArq: 'Mandado'
  },
  {
    id: 8,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Declaração de Pobreza',
    prefixoNomeArq: 'Declaracao_de_Pobreza'
  },
  {
    id: 9,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Procedimentos',
    prefixoNomeArq: 'Procedimentos'
  },
  {
    id: 10,
    livro: ['N', 'C', 'O', 'CR', 'NT'],
    desc: 'Requisições de Certidão',
    prefixoNomeArq: 'Requisicoes_de_Certidao'
  }
]
